/**
 * 📢 📢 📢 This file is autogenerated and may be overwritten. Handle with care. 🙅🏽 🙅🏽 🙅🏽
 *
 * When you have custom shipping repo integration, then the content of this file
 * will be overwritten during performing "npm install". So, in most of the cases,
 * you don't need to alter the content of this file.
 *
 * But, if you have your own custom shipping methods locally, then you need to
 * include them here as well. That is the only time you need to touch this file.
 */

export default {};
